// document.addEventListener('DOMContentLoaded', function () {
  
//   localStorage.clear();
//   const SITE_ID = '5op9sn';
//   const SECTION_ID = 'search-grid-2';
//   const CACHE_DURATION_MINUTES = 5;
//   const RESULTS_PER_PAGE = 9;

//   const pathParts = window.location.pathname.split('/').filter(Boolean);
//   const isCollectionPage = pathParts.includes('collections');
//   const collectionHandle = isCollectionPage ? pathParts[pathParts.indexOf('collections') + 1] : null;
//   if (!isCollectionPage || !collectionHandle) return;

//   const productGrid = document.querySelector('#product-grid-2');
//   if (!productGrid) {
//     console.warn('❗ #product-grid-2 not found — cannot render collection products.');
//     return;
//   }

//   const shopifyRoot = Shopify?.routes?.root || '/';
//   let currentPage = 1;
//   let isFetching = false;
//   let hasMorePages = true;

//   // --- Active State ---
//   var activeFilters = {product_type:[], tags_colour: [], variant_size: [], tags_fabric:[]}; // e.g. { color: ['Blue', 'Green'], size: ['M'] }
//   var activeSort = ''; // e.g. 'price:asc'
//   window.toggleFilter = toggleFilter; // call with toggleFilter('color', 'Blue')
//   window.applySort = applySort; // call with applySort('price', 'asc')
//   window.applyFilter = applyFilter; 
//   // ========================
//   // APPLY URL SORT ON PAGE LOAD
//   // ========================
//   const urlParams = new URLSearchParams(window.location.search);
//   const sortParam = urlParams.get('sort_by');
// // 1️⃣ Handle filters from URL (product_type, variant_size, tags_colour, tags_fabric)
// ['product_type', 'variant_size', 'tags_colour', 'tags_fabric'].forEach(key => {
//   const values = urlParams.getAll(key);
//   if (values.length > 0) {
//     if (!activeFilters[key]) activeFilters[key] = [];
//     values.forEach(v => {
//       activeFilters[key].push(v);
//     });
//   }
// });

//   if (sortParam) {
//     let field = '';
//     let direction = '';

//     switch (sortParam) {
//       case 'manual':
//         field = 'featured';
//         direction = 'desc';
//         break;
//       case 'title-ascending':
//         field = 'title';
//         direction = 'asc';
//         break;
//       case 'title-descending':
//         field = 'title';
//         direction = 'desc';
//         break;
//       case 'price-ascending':
//         field = 'ss_price';
//         direction = 'asc';
//         break;
//       case 'price-descending':
//         field = 'ss_price';
//         direction = 'desc';
//         break;
//       default:
//         field = 'featured';
//         direction = 'desc';
//     }

//     const radioInput = document.querySelector(`input[name="sort_by"][value="${sortParam}"]`);
//     if (radioInput) {
//       radioInput.checked = true;
//     }

//     activeSort = `${field}:${direction}`
//     // console.log(`[Collection] Applied sort from URL: ${sortParam} (${field}:${direction})`);
//   }

//   function toggleFilter(type, value) {
//     if (!activeFilters[type]) activeFilters[type] = [];
//     const index = activeFilters[type].indexOf(value);
//     if (index > -1) {
//       activeFilters[type].splice(index, 1);
//       if (activeFilters[type].length === 0) delete activeFilters[type];
//     } else {
//       activeFilters[type].push(value);
//     }
//     resetCollection();
//   }

//   function applySort(field, direction) {
//     activeSort = `${field}:${direction}`;
//     resetCollection();
//   }
//   function renderSearchspringFilters(facets) {
//   // console.log('facets', facets);
//   const filterContainer = document.querySelector('.filter-wrap');
//   if (!filterContainer) return;

//   // Clear existing filters
//   filterContainer.innerHTML = '';

//   facets.forEach(facet => {
//     // ❌ Skip price or range-type filters
//     if (
//       facet.field === 'ss_price' ||
//       facet.label?.toLowerCase().includes('price') ||
//       facet.type === 'range'
//     ) {
//       return;
//     }

//     // Skip if no values
//     if (!facet.values || facet.values.length === 0) return;

//     // Create facet wrapper with theme classes
//     const facetWrap = document.createElement('div');
//     facetWrap.className = 'facet-list filter-inr filter-index';
//     facetWrap.innerHTML = `
//       <div class="filter-title">
//         <span>${facet.label}</span>
//         <span>
//           <svg xmlns="http://www.w3.org/2000/svg" width="9" height="12" viewBox="0 0 9 12" fill="none">
//             <path d="M5.262 9.01699L5.262 0.812988L4.03 0.812988L4.03 9.01699L1.076 6.04899L0.291999 6.83299L4.646 11.187L9 6.83299L8.23 6.04899L5.262 9.01699Z" fill="black"></path>
//           </svg>
//         </span>
//       </div>
//       <ul class="filter-inr-wrap"></ul>
//     `;

//     const list = facetWrap.querySelector('.filter-inr-wrap');

//     // Loop through facet values
//     facet.values.forEach(v => {
//       const val = v.value || v.label || `${v.low}-${v.high}` || 'unknown';
//       const safeId = `${facet.field}-${val.replace(/\s+/g, '-').toLowerCase()}`;
//       const isChecked =
//         activeFilters[facet.field] &&
//         activeFilters[facet.field].includes(val);

//       const li = document.createElement('li');
//       li.innerHTML = `
//         <input class="facet-input"
//               type="checkbox"
//               id="${safeId}"
//               name="${facet.field}"
//               value="${val}"
//               ${isChecked ? 'checked' : ''}
//               onchange="toggleFilter('${facet.field}', '${val}')">
//         <label for="${safeId}">${v.label || val}</label>
//       `;
//       list.appendChild(li);
//     });

//     // Append the whole facet block
//     filterContainer.appendChild(facetWrap);
    
//     if (typeof filter_acco == 'function'){
//       filter_acco();
//     }
//     document.querySelectorAll('.filter-title').forEach(function(self){
//         self.addEventListener('click', function(event){
//             self.closest('.filter-index').classList.toggle('active');
//             self.closest('.filter-index').querySelector('.filter-inr-wrap').style.height = 'auto';
//         })
//     });
//     // document.querySelectorAll('.filter-title').forEach(function(self){
//     //     self.addEventListener('click', function(event){
//     //         self.closest('.filter-index').classList.toggle('active');
//     //         if (self.closest('.filter-index').classList.contains('active'))
//     //         {
//     //           self.closest('.filter-index').querySelector('.filter-inr-wrap').style.height = 'auto';
//     //         } else {
//     //           self.closest('.filter-index').querySelector('.filter-inr-wrap').style.height = '0px';
//     //         }
//     //     });
//     //     self.addEventListener('ontouchend', function(event){
//     //         self.closest('.filter-index').classList.toggle('active');
//     //         if (self.closest('.filter-index').classList.contains('active'))
//     //         {
//     //           self.closest('.filter-index').querySelector('.filter-inr-wrap').style.height = 'auto';
//     //         } else {
//     //           self.closest('.filter-index').querySelector('.filter-inr-wrap').style.height = '0px';
//     //         }
//     //     })
//     // });
//   });
// }
//   function applyFilter() {
//     activeFilters = {product_type:[], tags_colour: [], variant_size: [], tags_fabric:[]}; 
//     setTimeout(function(){
//       document.querySelectorAll('.wc_filter_option:checked').forEach(function(self){
//         var field_value = self.getAttribute('data-param-name');
//         if (field_value.includes('product_type')) {
//           activeFilters.product_type.push(self.value);
//         }
//         if (field_value.includes('filter.v.option.size')) {
//           activeFilters.variant_size.push(self.value);
//         }
//         if (field_value.includes('filter.p.m.custom.color')) {
//           activeFilters.tags_colour.push(self.value);
//         }
//         if (field_value.includes('filter.p.m.custom.fabric')) {
//           activeFilters.tags_fabric.push(self.value);
//         }
//       });
//       resetCollection();
//     }, 500);
//   }

//   function buildSearchspringParams() {
//     let params = [];

//     // Add filters
//     Object.entries(activeFilters).forEach(([key, values]) => {
//       values.forEach(val => {
//         params.push(`filter.${encodeURIComponent(key)}=${encodeURIComponent(val)}`);
//       });
//     });

//     // Add sorting
//     if (activeSort) {
//       const [field, dir] = activeSort.split(':');
//       params.push(`sort.${encodeURIComponent(field)}=${encodeURIComponent(dir)}`);
//     }

//     return params.join('&');
//   }

//   // ========================
//   // LOCAL CACHE HANDLERS
//   // ========================

//   function getCachedProduct(handle) {
//     const cacheKey = `product_html_${handle}`;
//     const cached = localStorage.getItem(cacheKey);
//     if (!cached) return null;
//     const parsed = JSON.parse(cached);
//     const now = Date.now();
//     if (now - parsed.timestamp < CACHE_DURATION_MINUTES * 60 * 1000) {
//       return parsed.html;
//     } else {
//       localStorage.removeItem(cacheKey);
//       return null;
//     }
//   }

//   function setCachedProduct(handle, html) {
//     const cacheKey = `product_html_${handle}`;
//     localStorage.setItem(
//       cacheKey,
//       JSON.stringify({ timestamp: Date.now(), html })
//     );
//   }

//   // ========================
//   // COLLECTION FETCH LOGIC
//   // ========================

//   async function fetchCollectionPage(page = 1) {
//     // console.log('page collection loaded');
//     if (isFetching || !hasMorePages) return;
//     isFetching = true;

//     const loader = document.querySelector('.look-cart-loader-inner');
//     if (loader) loader.style.display = 'flex';

//     try {
//       const extraParams = buildSearchspringParams();
//       const apiURL = `https://${SITE_ID}.a.searchspring.io/api/search/search.json?siteId=${SITE_ID}&resultsFormat=json&bgfilter.collection_handle=${collectionHandle}&page=${page}&resultsPerPage=${RESULTS_PER_PAGE}${
//         extraParams ? '&' + extraParams : ''
//       }`;

//       const response = await fetch(apiURL);
//       const data = await response.json();
//       if (page === 1 && data.facets) {
//         renderSearchspringFilters(data.facets);
//       }
//       if (!data.results || data.results.length === 0) {
//         if (page === 1) productGrid.innerHTML = `<div class="no-results">No products found.</div>`;
//         hasMorePages = false;
//         return;
//       }

//       const handles = data.results.map(p => p.handle).filter(Boolean);
//       const sectionPromises = handles.map(async (handle, index) => {
//       const cachedHTML = getCachedProduct(handle);
//       if (cachedHTML) return { index, html: cachedHTML, handle };

//       try {
//         const res = await fetch(`${shopifyRoot}products/${handle}?sections=${SECTION_ID}`);
//         const json = await res.json();
//         const html = json?.[SECTION_ID];

//         if (!html) {
//           const productData = data.results[index];
//           const fallbackHTML = `
//             <div class="fallback-product">
//               <a href="${shopifyRoot}products/${productData.handle}">
//                 <img src="${productData.imageUrl || productData.image || ''}" alt="${productData.name || ''}" loading="lazy">
//                 <h3>${productData.name || ''}</h3>
//                 <p>${productData.price || ''}</p>
//               </a>
//             </div>`;
//           setCachedProduct(handle, fallbackHTML);
//           return { index, html: fallbackHTML, handle };
//         }

//         setCachedProduct(handle, html);
//         if (!html || html.trim() === '' || html.trim() === `<div id="shopify-section-${SECTION_ID}" class="shopify-section"></div>`) {
//           return { index: ``, html: ``, handle: `` };
//         }else{
//           return { index, html, handle };
//         }
//       } catch (err) {
//         console.warn(`❌ Section fetch failed: ${handle}`, err);
//         return { index, html: ``, handle };
//       }
//     });

//       const sections = await Promise.all(sectionPromises);
//       sections.sort((a, b) => a.index - b.index);
//       const validSections = sections.filter(s => s.html && s.html.trim() !== '');
//       const combinedHTML = validSections.map(({ html }) => `<div class="product-item">${html}</div>`).join('');

//       if (combinedHTML.trim() !== '') {
//         productGrid.insertAdjacentHTML('beforeend', combinedHTML);
//       } else {
//         console.warn('⚠️ No valid product HTML found to insert.');
//       }
//       // const combinedHTML = sections.map(({ html }) => `<div class="product-item">${html}</div>`).join('');
//       // productGrid.insertAdjacentHTML('beforeend', combinedHTML);

//       $th_refreshWishlistItems?.();
//       quickAddButton2();
//       colorVariantClick2();
      
//       // console.log(`[Collection] Rendered page ${page} (${sections.length} products)`);
//       document.querySelector('.collection-grid.placeholder-grid').style.display = 'none';
//       if (data.pagination.currentPage == data.pagination.totalPages) {
//         document.querySelector('#AjaxinatePagination').style.display = 'none';
//       }
//       if (!data.pagination?.nextPage) hasMorePages = false;
//       currentPage++;
//     } catch (err) {
//       // console.error('❌ Error fetching collection products:', err);
//       if (currentPage === 1) {
//         productGrid.innerHTML = ``;
//       }
//     } finally {
//       isFetching = false;
//       if (loader) setTimeout(() => (loader.style.display = 'none'), 100);
//     }
//   }

//   // ========================
//   // PAGINATION / SCROLL
//   // ========================
//   window.addEventListener('scroll', () => {
//     if (isFetching || !hasMorePages) return;
//     const scrollY = window.scrollY + window.innerHeight;
//     const threshold = document.body.offsetHeight - 1000;
//     if (scrollY >= threshold) fetchCollectionPage(currentPage);
//   });

//   function resetCollection() {
//     // console.log('reset called');
//     productGrid.innerHTML = '';
//     currentPage = 1;
//     hasMorePages = true;
//     fetchCollectionPage(currentPage);
//   }

//   // ========================
//   // INITIAL LOAD
//   // ========================
//   fetchCollectionPage(currentPage);

//   // ========================
//   // QUICK ADD + COLOR VARIANT
//   // ========================
//   function quickAddButton2() {
//     document.querySelectorAll('.variant-grid').forEach(sizeList => {
//       sizeList.addEventListener('click', e => {
//         e.preventDefault();
//         const variant_id = sizeList.dataset.id;
//         const formData = { items: [{ id: variant_id, quantity: 1 }] };
//         fetch('/cart/add.js', {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify(formData),
//         })
//           .then(r => r.json())
//           .then(() => {
//             if (typeof load_cart === 'function') load_cart();
//           })
//           .catch(console.error);
//       });
//     });
//   }

//   function colorVariantClick2() {
//     if (window.innerWidth > 1024) {
//       document.querySelectorAll('.grid-bottom .main-color-variant .color-var.click').forEach(function (element) {
//         element.addEventListener('click', function (event) {
//           event.preventDefault();
//           const attVal = this.getAttribute('data-id');
//           const productItem = this.closest('.product-item');
//           if (!productItem) return;

//           const innerGrids = productItem.querySelectorAll('.snippet-product-grid .inner-product-grid');
//           innerGrids.forEach(function (innerGrid) {
//             if (attVal === innerGrid.getAttribute('data-id')) {
//               innerGrids.forEach(g => g.classList.remove('active'));
//               innerGrid.classList.add('active');
//             }
//           });
//         });
//       });
//     }
//   }
// });

// //  document.querySelectorAll('.filter-title').forEach(function(self){
// //         self.addEventListener(['ontouchend', 'click'], function(event){
// //             self.closest('.filter-index').classList.toggle('active');
// //             self.closest('.filter-index').querySelector('.filter-inr-wrap').style.height = 'auto';
// //         })
// //     });

// // if (window.innerWidth < 1224) {
// //   filter_acco();
// // }


document.addEventListener('DOMContentLoaded', function () {
  const SITE_ID = '5op9sn';
  const SECTION_ID = 'search-grid-2';
  const CACHE_DURATION_MINUTES = 30;
  const DEFAULT_RESULTS_PER_PAGE = 20;
  
  const pathParts = window.location.pathname.split('/').filter(Boolean);
  const isCollectionPage = pathParts.includes('collections');
  const collectionHandle = isCollectionPage ? pathParts[pathParts.indexOf('collections') + 1] : null;
  
  if (!isCollectionPage || !collectionHandle) return;

  const productGrid = document.querySelector('#product-grid-2');
  if (!productGrid) return;

  const parsedResultsPerPage = parseInt(productGrid.dataset.resultsPerPage, 10);
  const RESULTS_PER_PAGE = Number.isFinite(parsedResultsPerPage) && parsedResultsPerPage > 0
    ? parsedResultsPerPage
    : DEFAULT_RESULTS_PER_PAGE;

  const paginationContainer = document.querySelector('#collection-pagination');
  const collectionLoader = document.querySelector('.collection-loader');
  const shopifyRoot = Shopify?.routes?.root || '/';
  let isFetching = false;
  let fetchController = null;

  // Read initial page from URL
  const initialParams = new URLSearchParams(window.location.search);
  let currentPage = parseInt(initialParams.get('page')) || 1;

  // pagination mode + paging state (numbers | load | both)
  const rawPaginationMode = (productGrid.dataset.paginationMode || 'both').toLowerCase();
  const paginationMode = ['numbers', 'load', 'both'].includes(rawPaginationMode) ? rawPaginationMode : 'both';

  let totalPages = 1;
  let totalResults = 0;
  let loadedMinPage = currentPage;
  let loadedMaxPage = currentPage;

  // --- Featured Grids Configuration ---
  let featuredGridsConfig = [];
  try {
    const featuredGridsData = productGrid.dataset.featuredGrids || productGrid.getAttribute('data-featured-grids');
    if (featuredGridsData && featuredGridsData !== '[]' && featuredGridsData.trim() !== '') {
      featuredGridsConfig = JSON.parse(featuredGridsData);
      featuredGridsConfig = featuredGridsConfig.filter(config => {
        const hasCollection = config.collection_handle && config.collection_handle.trim() !== '';
        const hasImage = config.image_url && config.image_url.trim() !== '';
        const hasVideo = config.video_url && config.video_url.trim() !== '';
        return hasCollection && (hasImage || hasVideo);
      });
      featuredGridsConfig.sort((a, b) => a.position - b.position);
    }
  } catch (err) {
    featuredGridsConfig = [];
  }

  // --- Active State ---
  var activeFilters = {};
  var activeSort = '';

  window.toggleFilter = toggleFilter;
  window.applySort = applySort;
  window.applyFilter = applyFilter;

  // ========================
  // APPLY URL SORT/FILTERS ON PAGE LOAD
  // ========================
  const urlParams = new URLSearchParams(window.location.search);
  const sortParam = urlParams.get('sort_by');

  // Hydrate Searchspring filters from URL query params.
  // We treat every non-reserved key as a filter key to support any facet field.
  const reservedParams = new Set(['page', 'sort_by']);
  urlParams.forEach((value, key) => {
    if (reservedParams.has(key)) return;
    if (!value) return;
    if (!activeFilters[key]) activeFilters[key] = [];
    if (!activeFilters[key].includes(value)) activeFilters[key].push(value);
  });

  if (sortParam) {
    let field = '', direction = '';
    switch (sortParam) {
      case 'manual': field = 'featured'; direction = 'desc'; break;
      case 'title-ascending': field = 'title'; direction = 'asc'; break;
      case 'title-descending': field = 'title'; direction = 'desc'; break;
      case 'price-ascending': field = 'ss_price'; direction = 'asc'; break;
      case 'price-descending': field = 'ss_price'; direction = 'desc'; break;
      default: field = 'featured'; direction = 'desc';
    }
    const radioInput = document.querySelector(`input[name="sort_by"][value="${sortParam}"]`);
    if (radioInput) radioInput.checked = true;
    activeSort = `${field}:${direction}`;
  }

  function toggleFilter(type, value) {
    if (!activeFilters[type]) activeFilters[type] = [];
    const index = activeFilters[type].indexOf(value);
    if (index > -1) {
      activeFilters[type].splice(index, 1);
      if (activeFilters[type].length === 0) delete activeFilters[type];
    } else {
      activeFilters[type].push(value);
    }
    resetCollection({ scrollToTop: true });
  }

  function applySort(field, direction) {
    activeSort = `${field}:${direction}`;
    resetCollection({ scrollToTop: true });
  }

  function renderSearchspringFilters(facets) {
    const filterContainer = document.querySelector('.filter-wrap');
    if (!filterContainer) return;
    const sizeFilterUnderCollectionName = (filterContainer.dataset?.sizeFilterUnderCollectionName || '').toLowerCase();

    // Snapshot the single currently open facet before we destroy the DOM
    let openFacetField = null;
    let openFacetMaxHeight = '';
    document.querySelectorAll('.filter-index').forEach(el => {
      const title = el.querySelector('.filter-title');
      const wrap = el.querySelector('.filter-inr-wrap');
      const isOpen = title && title.classList.contains('active')
      if (isOpen) {
        const input = el.querySelector('.facet-input');
        if (input) {
          openFacetField = input.name;
          openFacetMaxHeight = wrap ? wrap.style.maxHeight : '';
        }
      }
    });

    const topFilterContainer = document.querySelector('.top-collection-filter');
    filterContainer.innerHTML = '';
    if (topFilterContainer) topFilterContainer.innerHTML = '';
    
    facets.forEach(facet => {
      if (facet.field === 'ss_price' || facet.label?.toLowerCase().includes('price') || facet.type === 'range') return;
      if (!facet.values || facet.values.length === 0) return;

      const wasOpen = facet.field === openFacetField;

      const facetWrap = document.createElement('div');
      facetWrap.className = 'facet-list filter-inr filter-index' + (wasOpen ? ' active' : '');
      facetWrap.innerHTML = `
        <div class="filter-title${wasOpen ? ' active' : ''}">
          <span class="filter-label">${facet.label}</span>
          <span>
            <svg xmlns="http://www.w3.org/2000/svg" width="9" height="12" viewBox="0 0 9 12" fill="none">
              <path d="M5.262 9.01699L5.262 0.812988L4.03 0.812988L4.03 9.01699L1.076 6.04899L0.291999 6.83299L4.646 11.187L9 6.83299L8.23 6.04899L5.262 9.01699Z" fill="black"></path>
            </svg>
          </span>
        </div>
        <ul class="filter-inr-wrap${wasOpen ? ' active' : ''}"${wasOpen && openFacetMaxHeight ? ` style="max-height:${openFacetMaxHeight}"` : ''}></ul>
      `;

      const list = facetWrap.querySelector('.filter-inr-wrap');
      let values = facet.values;

      if (facet.field === 'variant_size') {
        const sizeOrder = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL', 'OS'];
        const alphaSizes = [], numericSizes = [], others = [];

        values.forEach(v => {
          const val = (v.value || v.label || '').toUpperCase().trim();
          if (sizeOrder.includes(val)) alphaSizes.push(v);
          else if (/^[0-9]+$/.test(val)) numericSizes.push(v);
          else others.push(v);
        });

        alphaSizes.sort((a, b) => sizeOrder.indexOf((a.value||a.label||'').toUpperCase()) - sizeOrder.indexOf((b.value||b.label||'').toUpperCase()));
        numericSizes.sort((a, b) => parseInt(a.value) - parseInt(b.value));
        others.sort((a, b) => (a.label || '').localeCompare(b.label || ''));
        values = [...alphaSizes, ...numericSizes, ...others];
      }

      values.forEach(v => {
        const val = v.value || v.label || `${v.low}-${v.high}` || 'unknown';
        const safeId = `${facet.field}-${val.replace(/\s+/g, '-').toLowerCase()}`;
        const isChecked = activeFilters[facet.field] && activeFilters[facet.field].includes(val);

        const li = document.createElement('li');
        li.innerHTML = `
          <input class="facet-input" type="checkbox" form="form-facet" id="${safeId}" name="${facet.field}" value="${val}" ${isChecked ? 'checked' : ''} onchange="toggleFilter('${facet.field}', '${val}')">
          <label for="${safeId}">${v.label || val}</label>
        `;
        list.appendChild(li);
      });

      if (facet.field === 'ss_sizes' && sizeFilterUnderCollectionName === 'true' && topFilterContainer) {
        topFilterContainer.appendChild(facetWrap);
      } else {
        filterContainer.appendChild(facetWrap);
      }
    });

    // Recalculate maxHeight for open wraps after layout settles
    setTimeout(() => {
      document.querySelectorAll('.filter-index .filter-inr-wrap.active').forEach(wrap => {
        wrap.style.maxHeight = wrap.scrollHeight + 40 + 'px';
      });
      if (typeof filter_accod === 'function') filter_accod();
      if (typeof ensureGridImagesUpdate === 'function') ensureGridImagesUpdate();
    }, 300);
  }

  function applyFilter() {
    activeFilters = {};
    setTimeout(function () {
      document.querySelectorAll('.wc_filter_option:checked').forEach(function (self) {
        var field_value = self.getAttribute('data-param-name');
        if (field_value.includes('product_type')) activeFilters.product_type.push(self.value);
        if (field_value.includes('filter.v.option.size')) activeFilters.variant_size.push(self.value);
        if (field_value.includes('filter.p.m.custom.color')) activeFilters.tags_colour.push(self.value);
        if (field_value.includes('filter.p.m.custom.fabric')) activeFilters.tags_fabric.push(self.value);
      });
      resetCollection({ scrollToTop: true });
    }, 500);
  }

  function buildSearchspringParams() {
    let params = [];
    Object.entries(activeFilters).forEach(([key, values]) => {
      values.forEach(val => {
        params.push(`filter.${encodeURIComponent(key)}=${encodeURIComponent(val)}`);
      });
    });
    if (activeSort) {
      const [field, dir] = activeSort.split(':');
      params.push(`sort.${encodeURIComponent(field)}=${encodeURIComponent(dir)}`);
    }
    return params.join('&');
  }

  // ========================
  // PRODUCT HTML CACHE (localStorage, 30min TTL)
  // ========================
  function getCachedProduct(handle) {
    try {
      const cached = localStorage.getItem(`product_html_${handle}`);
      if (!cached) return null;
      const parsed = JSON.parse(cached);
      if (Date.now() - parsed.timestamp < CACHE_DURATION_MINUTES * 60 * 1000) return parsed.html;
      localStorage.removeItem(`product_html_${handle}`);
    } catch (e) {}
    return null;
  }

  function setCachedProduct(handle, html) {
    try {
      localStorage.setItem(`product_html_${handle}`, JSON.stringify({ timestamp: Date.now(), html }));
    } catch (e) {}
  }

  // ========================
  // URL + SPA NAVIGATION
  // ========================
  function buildPageUrl(page) {
    const url = new URL(window.location.href);
    if (page <= 1) {
      url.searchParams.delete('page');
    } else {
      url.searchParams.set('page', page);
    }
    // Sync active filters to URL so shared/copied links restore state on load.
    // Remove all non-reserved params first, then write current active filters.
    const reservedParams = new Set(['page', 'sort_by']);
    Array.from(url.searchParams.keys()).forEach((key) => {
      if (!reservedParams.has(key)) url.searchParams.delete(key);
    });
    Object.entries(activeFilters).forEach(([key, values]) => {
      if (!Array.isArray(values)) return;
      values.filter(Boolean).forEach(v => url.searchParams.append(key, v));
    });
    // Sync active sort to URL
    url.searchParams.delete('sort_by');
    if (activeSort) {
      const sortMap = {
        'featured:desc': 'manual',
        'title:asc': 'title-ascending',
        'title:desc': 'title-descending',
        'ss_price:asc': 'price-ascending',
        'ss_price:desc': 'price-descending',
      };
      const sortByValue = sortMap[activeSort];
      if (sortByValue) url.searchParams.set('sort_by', sortByValue);
    }
    return url.pathname + url.search;
  }

  function updateUrl(page, pushState) {
    const url = buildPageUrl(page);
    if (pushState) {
      history.pushState({ page }, '', url);
    } else {
      history.replaceState({ page }, '', url);
    }
  }

  function updateSeoLinks(page, totalPages) {
    document.querySelectorAll('link[rel="prev"], link[rel="next"]').forEach(el => el.remove());
    if (page > 1) {
      const prev = document.createElement('link');
      prev.rel = 'prev';
      prev.href = window.location.origin + buildPageUrl(page - 1);
      document.head.appendChild(prev);
    }
    if (page < totalPages) {
      const next = document.createElement('link');
      next.rel = 'next';
      next.href = window.location.origin + buildPageUrl(page + 1);
      document.head.appendChild(next);
    }
  }

  // ========================
  // PAGINATION COMPONENT
  // ========================
  function renderPagination(currentPage, totalPages, targetContainer = paginationContainer) {
    if (!targetContainer) return;
    if (totalPages <= 1) { targetContainer.innerHTML = ''; return; }

    const pages = [];
    const delta = 1;
    const rangeStart = Math.max(2, currentPage - delta);
    const rangeEnd = Math.min(totalPages - 1, currentPage + delta);

    pages.push(1);
    if (rangeStart > 2) pages.push('...');
    for (let i = rangeStart; i <= rangeEnd; i++) pages.push(i);
    if (rangeEnd < totalPages - 1) pages.push('...');
    if (totalPages > 1) pages.push(totalPages);

    let html = '<nav class="collection-pagination" aria-label="Collection pagination"><ul>';

    const prevArrow = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><g clip-path="url(#clip0_prev)"><path d="M7.78344 4.00039L4.35535 7.42848H13.8317V8.57119H4.35534L7.78344 11.9993L6.97544 12.8073L2.16797 7.99984L6.97544 3.19238L7.78344 4.00039Z" fill="black"/></g><defs><clipPath id="clip0_prev"><rect width="16" height="16" fill="white"/></clipPath></defs></svg>';
    const nextArrow = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><g clip-path="url(#clip0_next)"><path d="M8.21656 4.00039L11.6447 7.42848H2.16835V8.57119H11.6447L8.21656 11.9993L9.02456 12.8073L13.832 7.99984L9.02456 3.19238L8.21656 4.00039Z" fill="black"/></g><defs><clipPath id="clip0_next"><rect width="16" height="16" fill="white"/></clipPath></defs></svg>';

    if (currentPage > 1) {
      html += `<li><a href="${buildPageUrl(currentPage - 1)}" class="pagination-link pagination-prev" rel="prev" aria-label="Previous page" data-page="${currentPage - 1}">${prevArrow} Previous</a></li>`;
    } else {
      html += `<li><span class="pagination-link pagination-prev disabled" aria-disabled="true">${prevArrow} Previous</span></li>`;
    }

    pages.forEach(p => {
      if (p === '...') {
        html += `<li><span class="pagination-ellipsis">&hellip;</span></li>`;
      } else if (p === currentPage) {
        html += `<li><span class="pagination-link current" aria-current="page" aria-label="Page ${p}">${p}</span></li>`;
      } else {
        html += `<li><a href="${buildPageUrl(p)}" class="pagination-link" aria-label="Page ${p}" data-page="${p}">${p}</a></li>`;
      }
    });

    if (currentPage < totalPages) {
      html += `<li><a href="${buildPageUrl(currentPage + 1)}" class="pagination-link pagination-next" rel="next" aria-label="Next page" data-page="${currentPage + 1}">Next ${nextArrow}</a></li>`;
    } else {
      html += `<li><span class="pagination-link pagination-next disabled" aria-disabled="true">Next ${nextArrow}</span></li>`;
    }

    html += '</ul></nav>';
    targetContainer.innerHTML = html;

    targetContainer.querySelectorAll('a.pagination-link').forEach(link => {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        const page = parseInt(this.dataset.page, 10);
        if (page && page !== currentPage) navigateToPage(page, true);
      });
    });
  }

  function renderLoadButtons(targetContainer) {
    if (!targetContainer) return;

    const canLoadPrev = loadedMinPage > 1;
    const canLoadNext = loadedMaxPage < totalPages;

    if (!canLoadPrev && !canLoadNext) {
      targetContainer.innerHTML = '';
      return;
    }

    let html = '<div class="collection-load-actions">';
    if (canLoadPrev) {
      html += `<a href="${buildPageUrl(loadedMinPage - 1)}" class="pagination-prev js-load-prev btn-secondary" data-page="${loadedMinPage - 1}">Load Previous</a>`;
    }
    if (canLoadNext) {
      const nextPage = loadedMaxPage + 1;
      const nextPageCount = getPageItemCount(nextPage);
      const nextLabel = nextPageCount > 0 ? `View ${nextPageCount} More Items` : 'View More Items';
      html += `<a href="${buildPageUrl(nextPage)}" class="pagination-next js-load-next btn-secondary" data-page="${nextPage}">${nextLabel}</a>`;
    }
    html += '</div>';

    targetContainer.innerHTML = html;

    const prevBtn = targetContainer.querySelector('.js-load-prev');
    const nextBtn = targetContainer.querySelector('.js-load-next');

    if (prevBtn) {
      prevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        if (isFetching) return;
        const prevPage = loadedMinPage - 1;
        if (prevPage < 1) return;
        fetchCollectionPage(prevPage, { mode: 'prepend', pushState: false });
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        if (isFetching) return;
        const nextPage = loadedMaxPage + 1;
        if (nextPage > totalPages) return;
        fetchCollectionPage(nextPage, { mode: 'append', pushState: false });
      });
    }
  }

  function getPageItemCount(page) {
    if (page < 1 || page > totalPages) return 0;

    if (totalResults > 0) {
      if (page < totalPages) return RESULTS_PER_PAGE;
      return Math.max(totalResults - RESULTS_PER_PAGE * (totalPages - 1), 0);
    }

    return RESULTS_PER_PAGE;
  }

  function renderControls() {
    if (!paginationContainer) return;

    const showNumbers = paginationMode === 'numbers' || paginationMode === 'both';
    const showLoad = paginationMode === 'load' || paginationMode === 'both';

    paginationContainer.innerHTML = `
      <div class="pagination-numbers-slot"></div>
      <div class="pagination-load-slot"></div>
    `;

    const numbersSlot = paginationContainer.querySelector('.pagination-numbers-slot');
    const loadSlot = paginationContainer.querySelector('.pagination-load-slot');

    if (showNumbers) renderPagination(currentPage, totalPages, numbersSlot);
    if (showLoad) renderLoadButtons(loadSlot);

    const hasNumbersContent = numbersSlot && (numbersSlot.childElementCount > 0 || numbersSlot.textContent.trim().length > 0);
    const hasLoadContent = loadSlot && (loadSlot.childElementCount > 0 || loadSlot.textContent.trim().length > 0);

    // Container always has slot nodes, so :empty never matches it.
    // Explicitly toggle visibility when both slots are empty.
    if (!hasNumbersContent && !hasLoadContent) {
      paginationContainer.style.padding = '0';
      paginationContainer.style.marginTop = '-1px';
    } else {
      paginationContainer.style.removeProperty('padding');
      paginationContainer.style.removeProperty('marginTop');
    }
  }

  // ========================
  // SPA PAGE NAVIGATION
  // ========================
  function scrollToCollection() {
    const grid = document.querySelector('#collection-grid');
    if (!grid) return;
    const headerHeight = parseInt(getComputedStyle(document.body).getPropertyValue('--header-height')) || 0;
    const topBlock = document.querySelector('.collection-top-block');
    const topBlockHeight = topBlock ? topBlock.offsetHeight : 0;
    const top = grid.getBoundingClientRect().top + window.scrollY - headerHeight - topBlockHeight;
    window.scrollTo({ top, behavior: 'smooth' });
  }

  function navigateToPage(page, pushState) {
    if (isFetching) return;

    productGrid.innerHTML = '';
    const placeholder = document.querySelector('.collection-grid.placeholder-grid');
    if (placeholder) placeholder.style.display = '';

    scrollToCollection();
    fetchCollectionPage(page, { mode: 'replace', pushState });
  }

  // Handle browser back/forward
  window.addEventListener('popstate', function (event) {
    const page = event.state?.page || (parseInt(new URLSearchParams(window.location.search).get('page')) || 1);
    if (page !== currentPage || loadedMinPage !== page || loadedMaxPage !== page) {
      productGrid.innerHTML = '';
      const placeholder = document.querySelector('.collection-grid.placeholder-grid');
      if (placeholder) placeholder.style.display = '';
      scrollToCollection();
      fetchCollectionPage(page, { mode: 'replace', pushState: null });
    }
  });

  // ========================
  // FEATURED VIDEO INITIALIZATION
  // ========================
  function initFeaturedVideos() {
    const featuredVideos = document.querySelectorAll('.featured-section .featured-video');
    if (featuredVideos.length === 0) return;
    
    if ('IntersectionObserver' in window) {
      const videoObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          const video = entry.target;
          if (entry.isIntersecting) {
            const p = video.play(); if (p) p.catch(() => {});
          } else {
            video.pause();
          }
        });
      }, { threshold: 0.25 });
      
      featuredVideos.forEach(video => {
        video.muted = true;
        video.setAttribute('playsinline', '');
        video.setAttribute('autoplay', '');
        video.setAttribute('loop', '');
        video.setAttribute('muted', '');
        video.setAttribute('preload', 'metadata');
        videoObserver.observe(video);
      });
    } else {
      featuredVideos.forEach(video => {
        video.muted = true;
        video.setAttribute('playsinline', '');
        video.setAttribute('autoplay', '');
        video.setAttribute('loop', '');
        video.setAttribute('muted', '');
        video.setAttribute('preload', 'metadata');
        const p = video.play(); if (p) p.catch(() => {});
      });
    }
  }

  // ========================
  // COLLECTION FETCH LOGIC (PAGINATED)
  // ========================
  async function fetchCollectionPage(page = 1, options = {}) {
    const { mode = 'replace', pushState = false } = options; // replace | append | prepend
    if (isFetching) return;
    isFetching = true;

    if (fetchController) fetchController.abort();
    fetchController = new AbortController();
    const signal = fetchController.signal;

    if (collectionLoader) collectionLoader.style.display = 'flex';

    const prevScrollHeight = mode === 'prepend' ? productGrid.scrollHeight : 0;

    try {
      const extraParams = buildSearchspringParams();
      const apiURL = `https://${SITE_ID}.a.searchspring.io/api/search/search.json?siteId=${SITE_ID}&resultsFormat=json&beacon=true&bgfilter.collection_handle=${collectionHandle}&page=${page}&resultsPerPage=${RESULTS_PER_PAGE}${extraParams ? '&' + extraParams : ''}`;

      const response = await fetch(apiURL, { signal });
      if (!response.ok) throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      const data = await response.json();

      // Capture Beacon 2.0 responseId
      data.searchResponseId = data.responseId || null;

      totalPages = data.pagination?.totalPages || 1;
      totalResults = data.pagination?.totalResults || 0;

      if (mode === 'replace' && data.facets) {
        renderSearchspringFilters(data.facets);
      }

      if (!data.results || data.results.length === 0) {
        if (mode === 'replace') {
          // If user opens an out-of-range page (e.g. ?page=3 while only 2 pages exist),
          // load the last valid page instead of showing an empty-state message.
          if (page > 1 && totalPages > 0 && page > totalPages) {
            isFetching = false;
            fetchController = null;
            return fetchCollectionPage(totalPages, { mode: 'replace', pushState: false });
          }

          productGrid.innerHTML = `<div class="no-results">No products found.</div>`;
          totalResults = 0;
          currentPage = page;
          loadedMinPage = page;
          loadedMaxPage = page;
          if (typeof pushState === 'boolean') updateUrl(page, pushState);
        }
        renderControls();
        updateSeoLinks(currentPage, totalPages);
        return;
      }

      const handles = data.results.map(p => p.handle).filter(Boolean);

      const sectionPromises = handles.map(async (handle, index) => {
        const cachedHTML = getCachedProduct(handle);
        if (cachedHTML) return { index, html: cachedHTML, handle };

        try {
          const productURL = `${shopifyRoot}products/${handle}?sections=${SECTION_ID}`;
          const res = await fetch(productURL, { signal });
          if (!res.ok) throw new Error(`HTTP ${res.status}`);
          const json = await res.json();
          const html = json?.[SECTION_ID];

          if (!html || html.trim() === '' || html.trim() === `<div id="shopify-section-${SECTION_ID}" class="shopify-section"></div>`) {
            const productData = data.results[index];
            const fallbackHTML = `<div class="fallback-product"><a href="${shopifyRoot}products/${productData.handle}"><img src="${productData.imageUrl || productData.image || ''}" alt="${productData.name || ''}" loading="lazy"><h3>${productData.name || ''}</h3><p>${productData.price || ''}</p></a></div>`;
            setCachedProduct(handle, fallbackHTML);
            return { index, html: fallbackHTML, handle };
          }

          setCachedProduct(handle, html);
          return { index, html, handle };
        } catch (err) {
          if (err.name === 'AbortError') throw err;
          const productData = data.results[index];
          return { index, html: `<div class="fallback-product error"><a href="${shopifyRoot}products/${productData.handle}"><img src="${productData.imageUrl || productData.image || ''}" alt="${productData.name || ''}" loading="lazy"><h3>${productData.name || ''}</h3><p>View Product</p></a></div>`, handle };
        }
      });

      const sections = await Promise.all(sectionPromises);
      sections.sort((a, b) => a.index - b.index);
      const validSections = sections.filter(s => s.html && s.html.trim() !== '');

      let htmlToInsert = '';

      // Featured grids only for page 1 + replace
      if (mode === 'replace' && page === 1) {
        const isMobile = window.innerWidth <= 1024;
        const usedFeaturedGrids = new Set();
        let i = 0;
        let regularProductCount = 0;

        while (i < validSections.length) {
          let featuredGridConfig = null;
          if (featuredGridsConfig.length > 0) {
            for (const gc of featuredGridsConfig) {
              const configKey = `${gc.collection_handle}_${gc.position}_${gc.mobile_position}`;
              if (usedFeaturedGrids.has(configKey)) continue;
              const targetPos = isMobile ? gc.mobile_position : gc.position;
              if (regularProductCount === targetPos) {
                featuredGridConfig = gc;
                usedFeaturedGrids.add(configKey);
                break;
              }
            }
          }

          if (featuredGridConfig && (validSections.length - i) >= 4) {
            const products = validSections.slice(i, i + 4).map(s => s.html);
            const mediaType = featuredGridConfig.media_type || 'image';
            let imageUrl = featuredGridConfig.image_url || '';
            const imageAlt = featuredGridConfig.image_alt || '';
            let videoUrl = featuredGridConfig.video_url || '';
            let videoSources = featuredGridConfig.video_sources || null;
            const customUrl = featuredGridConfig.url || '';

            if (imageUrl && imageUrl.startsWith('//')) imageUrl = `https:${imageUrl}`;
            if (videoUrl && videoUrl.startsWith('//')) videoUrl = `https:${videoUrl}`;

            let mediaHTML = '';

            if (mediaType === 'video' && (videoUrl || videoSources)) {
              let videoTag = '';
              let parsedVideoSources = null;
              if (videoSources) {
                if (typeof videoSources === 'string') { try { parsedVideoSources = JSON.parse(videoSources); } catch (e) {} }
                else if (Array.isArray(videoSources)) parsedVideoSources = videoSources;
              }

              if (parsedVideoSources && Array.isArray(parsedVideoSources) && parsedVideoSources.length > 0) {
                const sourceTags = parsedVideoSources.map(source => {
                  const src = source.url || source.src || '';
                  const type = source.mime_type || source.type || 'video/mp4';
                  return src ? `<source src="${src}" type="${type}">` : '';
                }).filter(t => t).join('');
                if (sourceTags) videoTag = `<video autoplay muted loop playsinline preload="metadata" style="width:100%;height:100%;object-fit:cover;background:#000;" class="featured-video">${sourceTags}</video>`;
              }

              if (!videoTag && videoUrl) {
                videoTag = `<video src="${videoUrl}" autoplay muted loop playsinline preload="metadata" style="width:100%;height:100%;object-fit:cover;background:#000;" class="featured-video"></video>`;
              }

              if (videoTag) mediaHTML = customUrl ? `<a href="${customUrl}" class="featured-media-link">${videoTag}</a>` : videoTag;
            }

            if (!mediaHTML && imageUrl) {
              const img = `<img src="${imageUrl}" alt="${imageAlt}" loading="lazy" style="width:100%;height:100%;object-fit:cover;">`;
              mediaHTML = customUrl ? `<a href="${customUrl}" class="featured-image-link">${img}</a>` : img;
            }

            const isPositionZero = regularProductCount === 0;
            const positionClass = isPositionZero ? 'position-zero' : '';

            if (isMobile) {
              htmlToInsert += `<div class="featured-section ${positionClass}"><div class="product-item featured-2x2">${mediaHTML}</div></div>`;
              i += 4;
            } else {
              const isRight = featuredGridConfig.layout === 'right';
              const sectionClass = `featured-section ${isRight ? 'featured-right' : 'featured-left'} ${positionClass}`;
              if (isRight) {
                htmlToInsert += `<div class="${sectionClass}"><div class="product-item">${products[0]}</div><div class="product-item">${products[1]}</div><div class="product-item featured-2x2">${mediaHTML}</div><div class="product-item">${products[2]}</div><div class="product-item">${products[3]}</div></div>`;
              } else {
                htmlToInsert += `<div class="${sectionClass}"><div class="product-item featured-2x2">${mediaHTML}</div><div class="product-item">${products[0]}</div><div class="product-item">${products[1]}</div><div class="product-item">${products[2]}</div><div class="product-item">${products[3]}</div></div>`;
              }
              i += 4;
            }
          } else {
            htmlToInsert += `<div class="product-item">${validSections[i].html}</div>`;
            i++;
            regularProductCount++;
          }
        }
      } else {
        htmlToInsert = validSections.map(s => `<div class="product-item">${s.html}</div>`).join('');
      }

      if (mode === 'replace') {
        productGrid.innerHTML = htmlToInsert;
        loadedMinPage = page;
        loadedMaxPage = page;
      } else if (mode === 'append') {
        productGrid.insertAdjacentHTML('beforeend', htmlToInsert);
        loadedMaxPage = Math.max(loadedMaxPage, page);
      } else if (mode === 'prepend') {
        productGrid.insertAdjacentHTML('afterbegin', htmlToInsert);
        loadedMinPage = Math.min(loadedMinPage, page);
      }

      currentPage = page;

      if (typeof pushState === 'boolean') {
        updateUrl(page, pushState); // numbers => pushState(true), load => replaceState(false)
      }

      if (mode === 'prepend') {
        const newScrollHeight = productGrid.scrollHeight;
        const delta = newScrollHeight - prevScrollHeight;
        if (delta > 0) window.scrollBy({ top: delta, behavior: 'auto' });
      }

      // --- Beacon 2.0: Render + Impression + Click tracking ---
      if (window.SSBeacon && data.searchResponseId) {
        var _rid = data.searchResponseId;

        // Add data attributes to product cards
        var productItems = productGrid.querySelectorAll('.product-item');
        data.results.forEach(function(item, idx) {
          if (productItems[idx] && item.uid) {
            productItems[idx].setAttribute('data-ss-uid', item.uid);
            productItems[idx].setAttribute('data-ss-parent-id', item.uid);
          }
        });

        SSBeacon.searchRender(_rid);
        SSBeacon.observeSearchGrid(_rid, productGrid);
      }

      if (typeof $th_refreshWishlistItems === 'function') $th_refreshWishlistItems();
      window.GroupSwatches && window.GroupSwatches.init(productGrid);
      if (typeof window.initProductCardVideos === 'function') window.initProductCardVideos();
      setTimeout(initFeaturedVideos, 500);

      document.querySelector('.collection-grid.placeholder-grid')?.style?.setProperty('display', 'none');

      renderControls();
      updateSeoLinks(currentPage, totalPages);

    } catch (err) {
      if (err.name === 'AbortError') return;
      console.error('Error loading collection:', err);
      if (mode === 'replace') {
        productGrid.innerHTML = `
          <div class="error" style="padding: 20px; text-align: center;">
            <h3>Error loading products</h3>
            <p>${err.message}</p>
          </div>`;
      }
    } finally {
      isFetching = false;
      fetchController = null;
      if (collectionLoader) collectionLoader.style.display = 'none';
    }
  }

  // ========================
  // RESPONSIVE BREAKPOINT HANDLER
  // ========================
  let currentViewportIsMobile = window.innerWidth <= 1024;
  let resizeTimeout = null;

  function handleResize() {
    if (resizeTimeout) clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      if (isFetching) { setTimeout(handleResize, 500); return; }
      const newMobile = window.innerWidth <= 1024;
      if (currentViewportIsMobile !== newMobile) {
        currentViewportIsMobile = newMobile;
        resetCollection();
      }
    }, 250);
  }
  window.addEventListener('resize', handleResize);

  // ========================
  // RESET (for filter/sort changes)
  // ========================
  function resetCollection(options = {}) {
    const { scrollToTop = false } = options;

    currentPage = 1;
    loadedMinPage = 1;
    loadedMaxPage = 1;
    totalPages = 1;

    if (scrollToTop) {
      window.scrollTo(0, 0);
    }

    productGrid.innerHTML = '';
    const placeholder = document.querySelector('.collection-grid.placeholder-grid');
    if (placeholder) placeholder.style.display = '';

    // Keep URL in sync immediately when filters/sort change.
    updateUrl(1, true);
    fetchCollectionPage(1, { mode: 'replace', pushState: false });
  }

  // Optional behavior: on deep-link (?page>1) preload all previous pages
  const preloadPreviousOnDeepLink = true;
  const maxPreloadPages = 5; // safety cap

  async function initialLoad() {
    const targetPage = currentPage;

    // Only meaningful for load/both modes
    const canPreload = paginationMode === 'load' || paginationMode === 'both';

    if (!preloadPreviousOnDeepLink || !canPreload || targetPage <= 1) {
      await fetchCollectionPage(targetPage, { mode: 'replace', pushState: false });
      return;
    }

    // Safety cap (avoid huge first load on page=20, etc.)
    const cappedTarget = Math.min(targetPage, maxPreloadPages);

    await fetchCollectionPage(1, { mode: 'replace', pushState: false });
    for (let p = 2; p <= cappedTarget; p++) {
      await fetchCollectionPage(p, { mode: 'append', pushState: false });
    }

    // Keep URL on the originally requested page (if capped, keep capped page)
    currentPage = cappedTarget;
    loadedMinPage = 1;
    loadedMaxPage = cappedTarget;
    updateUrl(cappedTarget, false);
    renderControls();
  }

  // ========================
  // INITIAL LOAD
  // ========================
  initialLoad();
});